import React from 'react';

import Text from 'components/Text';

import styled from 'styled-components';
import { mobile, tablet, useQuery } from 'styles/breakpoints';
import { DynamicImage } from 'components';
import ContinueButton from './QuizContinueButton';

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 1;
  max-width: 28.75rem;
  width: 100%;
  padding: 3.5rem 0 7rem;
  @media ${tablet} {
    padding: 1.5rem 0;
    padding-bottom: 85px;
  }
  @media ${mobile} {
    padding: 2.47338rem 1rem;
  }
`;

const StyledImg = styled(DynamicImage)`
  width: 100%;
  margin-bottom: 1rem;
`;

const Description = styled(Text)`
  color: #fff;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
`;

const DescriptionBottom = styled(Description)`
  margin-top: 0.75rem;
  @media ${tablet} {
    line-height: 1.375rem;
  }
`;

const Title = styled(Text)`
  color: #fff;
  font-size: 1.375rem;
  font-style: normal;
  font-weight: 700;
  line-height: 1.875rem;
  margin-bottom: 0.5rem;
  max-width: 28.7rem;
  width: 100%;
  span {
    color: #f7c800;
  }
`;

type InfoTopImageProps = {
  title?: string;
  topTitle?: string;
  description?: string;
  description2?: string;
  image?: string;
  nextBtnTitle?: string;
  onContinue: () => void;
};

const InfoTopImage = ({
  title,
  description,
  description2,
  onContinue,
  image,
  nextBtnTitle,
}: InfoTopImageProps) => {
  const { isTablet, isMobile } = useQuery();

  return (
    <Container>
      {image && <StyledImg src={image} alt="" />}
      <Title dangerouslySetInnerHTML={{ __html: title }} />

      <Description
        textAlign={'left'}
        dangerouslySetInnerHTML={{ __html: description }}
      />

      <ContinueButton
        title={nextBtnTitle}
        color="primary"
        onClick={onContinue}
        cornerVariant="round"
      />
    </Container>
  );
};

export default InfoTopImage;
